import React from 'react';
import Paper from '@mui/material/Paper';
const BlockSProtocolConstructor = () => {
  return <Paper> BlockSProtocolConstructor блок конструктор протоколов</Paper>;
};

export default BlockSProtocolConstructor;
